import DashboardMyDemographics from './DashboardMyDemographics';

export default DashboardMyDemographics;